module.exports = "/assets/webpack/production/fonts/slick_f97e3bbf73254b0112091d0192f17aec.svg";